<template>
	
	    <v-dialog
            v-model="is_auto_sync_dialog_two_open"
            width="550" persistent>
            <v-card class="secure-modal proceed-modal csv-file-modal">
	            <v-card-title class="text-h5" persistent>
					<v-card-actions class="close-icon">
						<v-btn color="primary" text @click="closeDialogTwo()">
						   <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
						   </v-btn>
					</v-card-actions>
				</v-card-title>
	            <v-card-text v-if="dashboardType != 'retirement'">
	                <p>We will need the PAN numbers to read your statements and update records.</p>
	                <p>Please update PAN numbers for yourself and other members in the profile section if you have not already updated</p>
	                <form class="login-form-box register-page pricing-plan_modal-bottombox">            
		                <v-row>
		                  <v-col>
		                    <v-btn class="blue-btn"
		                      @click="proceedAutoTrackDialogThree()">
		                      Proceed   
		                    </v-btn>
		                  </v-col>
		                </v-row>
	                </form>
                  <br><br>
	                <p>Once PAN details are updated for members you can select member for whom you want to sync email.</p>
	            </v-card-text>

	            <v-card-text v-else>
	                <p>We need the PRAN numbers and Date of Birth yourself and members to track the investment details.</p>
	                <p>Please update Date of Birth in "Profile" Section you haven't already</p>
	                <form class="login-form-box register-page pricing-plan_modal-bottombox">            
		                <v-row>
		                  <v-col>
		                    <v-btn class="blue-btn"
		                      @click="proceedAutoTrackDialogThree()">
		                      Proceed   
		                    </v-btn>
		                  </v-col>
		                </v-row>
	                </form>
                  <br><br>
	                <p>Once details are updated for members you can select member for whom you want to sync email.</p>

	            </v-card-text>
          </v-card>
	</v-dialog>
</template>	
<script>
    import { Auth } from "aws-amplify";
    import Datepicker from 'vuejs-datepicker';
    export default {
 		components: {
		  Datepicker,
		},
	  	props: ['is_auto_sync_dialog_two_open_status', 'get_auto_sync_dialog_two_data', 'getDashboardType'],
	  	data: function () {
		    return { 
			  	is_auto_sync_dialog_two_open:this.is_auto_sync_dialog_two_open_status,
          delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete-icon.png',
          dashboardType:this.getDashboardType
		    }
		},

		methods:{
			proceedAutoTrackDialogThree(){
        this.$emit('allowAutoSyncDialogThree', true);        
			},

			closeDialogTwo(){
				this.$emit('allowAutoSyncDialogThree', false);        
			}
		}
	}	
</script>
<style scoped>
  .tex_color{
  	  color: #0144AF !import;
  }
</style>    	